import * as actionTypes from "./../actions/actionTypes";
import { IInvestorSearchParams } from "../../interfaces/investor";

const initialState: IInvestorSearchParams = {
  searchValue: "",
  searchBy: 3,
  aggregatorId: "",
  email: "",
};

const reducer = (
  state = initialState,
  action: { type: string; payload: IInvestorSearchParams },
) => {
  switch (action.type) {
    case actionTypes.SET_ADVANCED_INVESTOR_SEARCH_PARAMS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
